import { useState } from "react";
import { Link } from "react-router-dom";
import { C } from "../constants/theme";
import { useSiteContent } from "../context/SiteContentContext";
import FadeIn from "../components/ui/FadeIn";
import TiltCard from "../components/ui/TiltCard";
import RainbowDivider from "../components/ui/RainbowDivider";

const COURSES = [
  { icon:"🤲", color:C.coral,   title:"Holistic Tarbiyah Training for Mothers",   body:"A standalone training built specifically for mothers — the Tarbiyah pillar of our HT4 framework, its own dedicated track for raising and nurturing with intention." },
  { icon:"🎓", color:C.mint,    title:"Holistic Teaching Training for Educators", body:"A standalone training built specifically for educators — the Teaching pillar of our HT4 framework, open to teachers beyond our own classrooms." },
  { icon:"🌟", color:C.yellow,  title:"Mini Muslims Identity Course",             body:"A standalone course built around one goal: a child who owns their Muslim identity, not just recites it." },
  { icon:"🔍", color:"#4EA8DE", title:"Quran Tafseer for Kids",                   body:"A dedicated deep-dive into understanding the meaning behind the verses — for children ready to go beyond recitation." },
];

const WHATSAPP_NUMBER = "923390002106";

const UpcomingPrograms = () => {
  const { content } = useSiteContent();
  const ct = content.contact;
  const whatsappNumber = (ct?.whatsappLink || `https://wa.me/${WHATSAPP_NUMBER}`).replace(/\D/g, "").slice(-12) || WHATSAPP_NUMBER;
  const [name, setName] = useState("");
  const [interest, setInterest] = useState("any");

  const notifyLink = () => {
    const who = name.trim() ? `My name is ${name.trim()}. ` : "";
    const what = interest === "any" ? "these upcoming courses" : `the "${interest}" course`;
    const text = `Assalamu Alaikum! ${who}Please notify me when ${what} open${interest === "any" ? "" : "s"} for registration.`;
    return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
  };

  return (
    <div style={{ paddingTop: 72 }}>
      {/* ── Hero ── */}
      <section style={{ background:`linear-gradient(160deg,${C.navy} 0%,#0f2a70 100%)`, padding:"100px 6vw 90px", position:"relative", overflow:"hidden", minHeight:"46vh", display:"flex", alignItems:"center" }}>
        <div style={{ position:"absolute", top:-80, right:-80, width:400, height:400, borderRadius:"50%", background:`${C.yellow}12`, pointerEvents:"none" }}/>
        <div style={{ maxWidth:1100, margin:"0 auto", position:"relative", zIndex:2 }}>
          <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:`${C.yellow}22`, border:`1px solid ${C.yellow}50`, color:C.yellow, fontFamily:"Nunito", fontWeight:700, fontSize:11, letterSpacing:"0.15em", padding:"6px 16px", borderRadius:100, textTransform:"uppercase", marginBottom:20 }}>Coming Soon</div>
          <h1 style={{ fontFamily:"Fredoka One", fontSize:"clamp(28px,5vw,52px)", color:C.white, lineHeight:1.1, margin:"0 0 18px", maxWidth:700 }}>
            Upcoming Courses.
          </h1>
          <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:"clamp(14px,2vw,18px)", color:"rgba(255,255,255,0.85)", maxWidth:600, lineHeight:1.8, margin:0 }}>
            Four standalone courses, currently in development — for mothers, educators, and children alike, all built on the same HT4 framework behind everything we teach.
          </p>
        </div>
      </section>

      {/* ── Courses ── */}
      <section style={{ background:C.cream, padding:"90px 6vw" }}>
        <div style={{ maxWidth:1000, margin:"0 auto" }}>
          <FadeIn>
            <div style={{ textAlign:"center", marginBottom:44 }}>
              <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.navy, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:12 }}>In Development</div>
              <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,38px)", color:C.navy, margin:0 }}>Our Upcoming Courses.</h2>
              <RainbowDivider />
            </div>
          </FadeIn>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(400px,1fr))", gap:20 }}>
            {COURSES.map(({ icon, color, title, body }, i) => (
              <FadeIn key={title} delay={i * 0.08}>
                <TiltCard maxTilt={4} style={{ background:C.white, borderRadius:20, padding:"26px 22px", border:`2px solid ${color}22`, boxShadow:"0 4px 16px rgba(0,0,0,0.05)" }}>
                  <div style={{ fontSize:30, marginBottom:12 }}>{icon}</div>
                  <div style={{ fontFamily:"Fredoka One", fontSize:17, color, marginBottom:8 }}>{title}</div>
                  <p style={{ fontFamily:"Nunito", fontSize:13, color:C.text, lineHeight:1.75, margin:0 }}>{body}</p>
                </TiltCard>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ── Notify me ── */}
      <section style={{ background:C.cream, padding:"90px 6vw" }}>
        <div style={{ maxWidth:560, margin:"0 auto" }}>
          <FadeIn>
            <div style={{ background:C.white, borderRadius:24, padding:"40px 36px", boxShadow:"0 8px 32px rgba(0,0,0,0.07)", textAlign:"center" }}>
              <div style={{ fontSize:40, marginBottom:14 }}>🔔</div>
              <h2 style={{ fontFamily:"Fredoka One", fontSize:22, color:C.navy, margin:"0 0 8px" }}>Be the First to Know</h2>
              <p style={{ fontFamily:"Nunito", fontSize:13.5, color:C.muted, lineHeight:1.7, margin:"0 0 24px" }}>
                Tell us what you're interested in and send — it opens WhatsApp with your request pre-filled.
              </p>
              <input
                type="text" placeholder="Your Name (optional)" value={name} onChange={e=>setName(e.target.value)}
                style={{
                  width:"100%", padding:"12px 15px", border:`2px solid ${C.navy}18`, borderRadius:12,
                  fontFamily:"Nunito", fontSize:14, color:C.text, background:C.white, outline:"none",
                  boxSizing:"border-box", marginBottom:14,
                }}
              />
              <div style={{ display:"flex", gap:8, justifyContent:"center", marginBottom:20, flexWrap:"wrap" }}>
                {[
                  ["any","Any / All"],
                  ["Holistic Tarbiyah Training for Mothers","Tarbiyah for Mothers"],
                  ["Holistic Teaching Training for Educators","Teaching for Educators"],
                  ["Mini Muslims Identity Course","Identity Course"],
                  ["Quran Tafseer for Kids","Tafseer for Kids"],
                ].map(([val,label]) => (
                  <button key={val} onClick={()=>setInterest(val)} style={{
                    background: interest === val ? C.navy : C.white,
                    color: interest === val ? C.white : C.navy,
                    border:`2px solid ${C.navy}`, fontFamily:"Nunito", fontWeight:700, fontSize:12,
                    padding:"7px 14px", borderRadius:100, cursor:"pointer", transition:"all 0.2s",
                  }}>{label}</button>
                ))}
              </div>
              <a href={notifyLink()} target="_blank" rel="noopener noreferrer" style={{
                display:"block", background:"#25D366", color:C.white, textDecoration:"none",
                fontFamily:"Nunito", fontWeight:800, fontSize:15, padding:"15px", borderRadius:100,
              }}>💬 Notify Me via WhatsApp</a>
            </div>
          </FadeIn>
        </div>
      </section>

      <section style={{ background:C.cream, padding:"0 6vw 70px" }}>
        <div style={{ maxWidth:560, margin:"0 auto", textAlign:"center", display:"flex", gap:20, justifyContent:"center", flexWrap:"wrap" }}>
          <Link to="/resources" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13.5, color:C.navy, textDecoration:"none" }}>Looking for our paid resources instead? →</Link>
          <Link to="/free-resources" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13.5, color:C.navy, textDecoration:"none" }}>Or our free resources →</Link>
        </div>
      </section>
    </div>
  );
};

export default UpcomingPrograms;
